import { parseUrl } from '../helpers/parseUrl';
import useLocalStorage from '../Hooks/useLocalStorage';
import { createContext, useContext, useLayoutEffect } from 'react';

const initialState = {
  countryType: '',
  adminCountryType: '',
  siteUrl: '',
};

const CountryTypeContext = createContext(initialState);

const CountryTypeProvider = ({ children, ...props }) => {
  const [countryType, setCountryType] = useLocalStorage(
    'countryType',
    initialState.countryType
  );
  const [adminCountryType, setAdminCountryType] = useLocalStorage(
    'adminCountryType',
    initialState.countryType
  );

  useLayoutEffect(() => {
    //FOR LOCAL DEV ONLY
    const urlParams = new URLSearchParams(window.location.search);
    const mockHost = urlParams.get('mockHost');
    //
    const hostname = mockHost || window.location.hostname;
    const countryDetails = parseUrl(hostname);

    if (countryDetails.isAdmin) {
      setAdminCountryType(countryDetails.countryType);
    } else {
      setAdminCountryType('');
    }

    setCountryType(countryDetails.countryType);
  }, [setCountryType, setAdminCountryType]);

  const value = {
    countryType,
    setCountryType,
    adminCountryType,
    setAdminCountryType,
  };
  return (
    <CountryTypeContext.Provider value={value} {...props}>
      {children}
    </CountryTypeContext.Provider>
  );
};

export const useCountryType = () => {
  const value = useContext(CountryTypeContext);
  return value;
};

export default CountryTypeProvider;
